import https from "./https"
import store from "@/store"

const organization = store.state.general.organization;

// 徽章活動 badgeCampaign
const badgeCampaign = {
  getBadgeCampaigns(merchantId, params) {
    return https.get(
      `admin/organizations/${organization.id}/merchants/${merchantId}/badge-campaigns`, 
      { params }
    );
  },

  createBadgeCampaign(merchantId, params) {
    return https.post(
      `admin/organizations/${organization.id}/merchants/${merchantId}/badge-campaigns`, 
      params
    );
  },

  getBadgeCampaign(id) {
    return https.get(`admin/organizations/${organization.id}/badge-campaigns/${id}`);
  },

  updateBadgeCampaign(id, params) {
    return https.put(`admin/organizations/${organization.id}/badge-campaigns/${id}`, params);
  },

  deleteBadgeCampaign(id) {
    return https.delete(`admin/organizations/${organization.id}/badge-campaigns/${id}`);
  },
}

export default badgeCampaign